import styled from 'styled-components';
import { FieldProps } from 'lib/iterable-hook-form/FormField/types';
import { Controller } from 'react-hook-form';
import { Checkbox, CheckboxProps } from 'ui/checkboxV2';
import { spacing, colors } from 'ui/theme';

export const ContentWrapper = styled.div`
  padding-left: ${spacing.double};
  color: ${colors.textSecondary};
`;

type DisclosureProps = FieldProps &
  Omit<CheckboxProps, 'status' | 'onClick'> & {
    children?: React.ReactNode;
    labelText?: React.ReactNode;
  };

/**
 * Checkbox which hides/shows `children` content based on Checkbox status
 * @param children Content to display when checkbox is checked
 * @param name Name of field provided for form validation
 * @returns
 */
export const DisclosureCheckbox = ({ children, name, ...rest }: DisclosureProps) => {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <>
          <Checkbox {...rest} id={name} setChecked={onChange} status={value} />
          {value && <ContentWrapper>{children}</ContentWrapper>}
        </>
      )}
    />
  );
};
